import { actions } from 'Data/ReduxViewModels/Barcode';
import { WorkflowType } from 'Data/ReduxViewModels/Barcode/types';
import { hasValue } from 'Lib/Any';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

export function BarcodeNavigator() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const barcodeType = useSelector((state) => state.barcode.activeWorkflow?.WorkflowType);
  const resultUUID = useSelector((state) => state.barcode.activeWorkflow?.ResourceId);
  const worksheetUUID = useSelector((state) => state.barcode.activeWorkflow?.WorksheetId);
  const isSyncing = useSelector((state) => state.barcode.isSyncing);
  const isFrame = useSelector(() => window.qest.isFrame);

  useEffect(() => {
    if (isFrame || isSyncing || !hasValue(barcodeType)) return;

    var state = hasValue(resultUUID) ? { state: { focusUUID: resultUUID } } : undefined;
    switch (barcodeType) {
      case WorkflowType.Invalid:
        return;

      case WorkflowType.MoistureTinRegistration:
        //If we register a tin with a test on the Wet Mass Entry, then use the navigation/auto-focusing to move to the tare mass field
        if (location.pathname === '/grid/wet-mass-entry') navigate(`/grid/wet-mass-entry`, state);
        break;

      case WorkflowType.DryMassEntry:
        navigate(`/grid/dry-mass-entry`, state);
        break;

      case WorkflowType.Worksheet:
        //If we scan a tin that is is ready for Tare/WetMass to be entered and we are on the Wet Mass Entry grid, then instead of moving
        //to the worksheet we want to move into the next field for data entry.
        if (location.pathname === '/grid/wet-mass-entry' && hasValue(resultUUID))
          navigate(`/grid/wet-mass-entry`, state);
        else if (worksheetUUID && !location.pathname.endsWith(worksheetUUID))
          navigate(`/worksheets/${worksheetUUID}`, state);
        break;
    }

    dispatch(actions.barcodeClear());
  }, [isSyncing, resultUUID, worksheetUUID, barcodeType, isFrame, location.pathname, navigate, dispatch]);
}
